import isSSR from "../Config/isSSR";
export const apiURL = () => {
    return isSSR() ? process.env.REACT_APP_API_URL_SERVER : process.env.REACT_APP_API_URL
}